import { footer } from "./elements.js";
import { lenghtCorrect } from "./helpers.js";

export default function adaptiveElements() {

  if (matchMedia("(max-width: 380px)").matches) {
    const footerTitle =
      footer.querySelector(".footer__title").firstElementChild;
    const footerTitleText = footerTitle.innerText;
    fixedFooterTitle();
    window.addEventListener("resize", () => fixedFooterTitle());

    function fixedFooterTitle() {
      if (matchMedia("(max-width: 330px)").matches) {
        return (footerTitle.innerText = lenghtCorrect(footerTitleText, 30));
      }
      if (matchMedia("(max-width: 380px)").matches) {
        return (footerTitle.innerText = lenghtCorrect(footerTitleText, 33));
      }
      if (matchMedia("(min-width: 381px)").matches) {
        return (footerTitle.innerText = footerTitleText);
      }
    }
  }
}
